<div>
    Deseja reiniciar a conexão <strong>{{updateData.connection.connectionId}}</strong>? O pod será recriado e a conexão ficará indisponível por alguns instantes.
    <div class="mt-2 d-flex gap-2">
        <button (click)="confirm()" class="btn btn-primary">Confirmar</button>
        <button (click)="cancel()" class="btn btn-danger">Cancelar</button>
    </div>
</div>
